// AccompanyingEquipmentFormModal.vue
<template>
  <b-modal
    ref="modal"
    static
    :visible="show"
    :title="modalTitle"
    header-bg-variant="light"
    @hidden="resetForm"
    @close="close"
    @cancel="close"
    @ok.prevent="handleSubmit"
    :ok-disabled="isSubmitting"
    no-close-on-backdrop
    centered
  >
    <b-form @submit.prevent="handleSubmit" ref="form">
      <b-form-group
        label="Tên thiết bị:"
        label-for="name-input"
        :state="isValidName"
        :invalid-feedback="nameInvalidFeedback"
      >
        <b-form-input
          id="name-input"
          v-model="form.name"
          :state="isValidName"
          required
          placeholder="Nhập tên thiết bị kèm theo"
          maxlength="255"
          :disabled="isSubmitting"
        ></b-form-input>
      </b-form-group>

      <b-form-group label-for="active-input">
        <b-form-checkbox
          id="active-input"
          v-model="form.isActive"
          :disabled="isSubmitting"
          switch
        >
          {{ form.isActive ? 'Hoạt động' : 'Không hoạt động' }}
        </b-form-checkbox>
      </b-form-group>
    </b-form>

    <template #modal-footer="{ ok, cancel }">
      <b-button variant="secondary" :disabled="isSubmitting" @click="cancel()">
        Hủy bỏ
      </b-button>
      <b-button
        variant="primary"
        :disabled="isSubmitting || !isFormValid"
        @click="handleSubmit"
      >
        <b-spinner small v-if="isSubmitting" class="mr-1"></b-spinner>
        {{ isEdit ? 'Cập nhật' : 'Thêm mới' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { AccompanyingEquipmentService } from './service/accompanying-equipment.service';
import { makeToastSuccess, makeToastFaile } from '@/utils/common';

export default {
  name: 'AccompanyingEquipmentFormModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    equipment: {
      type: Object,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSubmitting: false,
      form: {
        name: '',
        isActive: true,
      },
      validationErrors: {
        name: '',
      },
    };
  },
  computed: {
    modalTitle() {
      return this.isEdit
        ? `Chỉnh sửa thiết bị: ${this.equipment?.name || ''}`
        : 'Thêm mới thiết bị kèm theo';
    },
    isValidName() {
      return this.validationErrors.name ? false : null;
    },
    nameInvalidFeedback() {
      return this.validationErrors.name;
    },
    isFormValid() {
      return !!this.form.name;
    },
  },
  watch: {
    equipment(newVal) {
      if (newVal) {
        this.initForm();
      }
    },
  },
  methods: {
    initForm() {
      if (this.equipment) {
        this.form = {
          ...this.form,
          ...this.equipment,
        };
      }
    },
    resetForm() {
      this.form = {
        name: '',
        isActive: true,
      };
      this.validationErrors = {
        name: '',
      };
    },
    validateForm() {
      this.validationErrors = {
        name: '',
      };

      if (!this.form.name.trim()) {
        this.validationErrors.name = 'Tên thiết bị không được để trống';
      }

      return !this.validationErrors.name;
    },
    handleSubmit() {
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;
      const payload = {
        name: this.form.name.trim(),
        isActive: this.form.isActive,
      };

      const request = this.isEdit
        ? AccompanyingEquipmentService.update(this.equipment.id, payload)
        : AccompanyingEquipmentService.create(payload);

      request
        .then((response) => {
          if (response.data.status === 200) {
            const message = this.isEdit
              ? 'Cập nhật thiết bị kèm theo thành công!'
              : 'Thêm mới thiết bị kèm theo thành công!';

            makeToastSuccess(message);
            this.$emit('equipment-saved', response.data.data);
          } else {
            makeToastFaile(
              response.data.message || 'Có lỗi xảy ra, vui lòng thử lại sau!',
            );
          }
        })
        .catch((error) => {
          console.error('Error saving equipment:', error);

          if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            const errors = error.response.data.errors;
            Object.keys(errors).forEach((key) => {
              if (key in this.validationErrors) {
                this.validationErrors[key] = errors[key];
              }
            });
          } else {
            makeToastFaile(
              error.message || 'Có lỗi xảy ra, vui lòng thử lại sau!',
            );
          }
        })
        .finally(() => {
          this.isSubmitting = false;
          if (!Object.values(this.validationErrors).some((v) => v)) {
            this.close();
          }
        });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>